module.exports = __webpack_public_path__ + "commercial_x.aef23a51dbe3327ccd30.jpg";